export const suscription = {
  p1: `Gerencie os detalhes do seu plano atual e explore opções para fazer upgrade ou alterar sua assinatura.`,
  p2: `Plano anual`,
  p3: `Plano mensal`,
  p4: `Ativo até`,
  p5: `Por quarto por mês`,
  p6: `Por acomodação por mês`,
  p7: `Número de ocupação`,
  p8: `Por ocupação por mês`,
  p9: `Atualizar assinatura`,
  p10: `Serviços ativos`,
  p11: `Ativo`,
  p12: `Inativo`,
  p13: `Convide seus hóspedes a fazer o check-in pelo WhatsApp, agendando-o antes da chegada à acomodação.`,
  p14: `Avaliações`,
  p15: `Convide seus hóspedes a avaliar a experiência e melhore a reputação da sua acomodação com avaliações positivas.`,
  p16: `Acesso remoto`,
  p17: `Cadastre e gerencie quartos equipados com fechaduras inteligentes. Configure os códigos de acesso que serão fornecidos aos hóspedes.`,
  p18: `Verificação de identidade`,
  p19: `Verificamos a identidade dos hóspedes comparando a foto do documento ou passaporte com uma selfie em tempo real.`,
  p20: `Gerenciar assinatura e formas de pagamento`,
  p21: `Adicione ou remova cartões conforme necessário`,
  p22: `Sua assinatura atual é gratuita`,
  p23: `Faça upgrade da sua assinatura para acessar recursos avançados.`,
  p24: `Sua assinatura gratuita expira em`,
  p25: `dia`,
  p26: `dias`,
  p27: `Não perca o acesso aos recursos avançados; faça upgrade da sua assinatura agora`,
  p28: `Personalize seu plano com serviços adicionais`,
  p29: `ocupação`,
  p30: `mês`,
  p31: `Avaliações`,
  p32: `Acesso remoto`,
  p33: `barraca`,
  p34: `vila`,
  p35: `Verificação de identidade`,
  p36: `OCUPAÇÃO TOTAL`,
  p37: `A ocupação total refere-se à capacidade máxima de pessoas permitidas em todos os seus Apartamentos, por exemplo, (se você selecionar 5 apartamentos, sua ocupação total pode ser 20 lugares). Informar a ocupação total nos ajuda a gerenciar sua assinatura com precisão e a cumprir as normas de segurança.`,
  p38: `A ocupação total refere-se à capacidade máxima de pessoas permitidas na sua Vila, por exemplo, (se você selecionar 5 apartamentos, sua ocupação total pode ser 20 lugares). Informar a ocupação total nos ajuda a gerenciar sua assinatura com precisão e a cumprir as normas de segurança.`,
  p39: `A ocupação total refere-se à capacidade máxima de pessoas permitidas no seu Hotel - Hostel, por exemplo, (se você selecionar 5 apartamentos, sua ocupação total pode ser 20 lugares). Informar a ocupação total nos ajuda a gerenciar sua assinatura com precisão e a cumprir as normas de segurança.`,
  p40: `A ocupação total refere-se à capacidade máxima de pessoas permitidas no seu Camping, por exemplo, (se você selecionar 5 apartamentos, sua ocupação total pode ser 20 lugares). Informar a ocupação total nos ajuda a gerenciar sua assinatura com precisão e a cumprir as normas de segurança.`,
  p41: `Você deve informar a ocupação total das suas propriedades.`,
  p42: `WACheckin WhatsApp`,
  p43: `Seu WhatsApp Business`,
  p44: `por ocupação/mês`,
  p45: `por quarto/mês`,
  p46: `Anual`,
  p47: `Ativar assinatura`,
  p48: `Atualizar assinatura`,
  p49: `Assinatura selecionada`,
  p50: `Número de`,
  p51: `quarto`,
  p52: `acomodação`,
  p53: `Preço mensal por`,
  p54: `quartos`,
  p55: `acomodações`,
  p56: `Número de ocupação selecionado`,
  p57: `Preço mensal por`,
  p58: `ocupação`,
  p59: `Tipo de assinatura`,
  p60: `Anual`,
  p61: `Mensal`,
  p62: `Serviços adicionais:`,
  p63: `Nenhum serviço adicionado`,
  p64: `Recomendamos adicionar o serviço do WhatsApp`,
  p65: `Avaliações`,
  p66: `Total a pagar`,
  p67: `Prosseguir com o pagamento`,
  p68: `Atualizar assinatura`,
  p69: "ChatBot",

  p70: `Assinatura`,
  p71: `Ativo`,
  p72: `Serviços adicionais opcionais`,

  p73: `Você tem novas propriedades para gerenciar?`,

  p74: `Detalhes da sua atualização e novos serviços`,
  p75: `A cobrança por serviços ou propriedades adicionais será aplicada proporcionalmente, considerando os dias restantes do mês na sua assinatura atual.`,
  p76: `Isso garante que você pague apenas pelo tempo exato de uso até a renovação do seu plano.`,

  p77: `Propriedades adicionadas`,
  p78: `Serviços adicionais`,
  p79: `Acesso remoto`,
  p80: `ChatBot IA`,
  p81: `Preço`,
  p82: `Anual`,
  p83: `Mensal`,
  p84: `Atualizar assinatura`,

  p85: `Propriedades assinadas`,
  p86: `Serviços adicionais`,
  p87: `Nenhum serviço adicional contratado`,
  p88: `ChatBot IA`,
  p89: `Acesso remoto`,

  p90: `Incluído no plano`,

  p91: `Preço por ano`,
  p92: `Preço por mês`,

  p93: `Status`,
  p94: `Ativo`,
  p95: `Expira`,

  p96: `Cadastre e gerencie quartos equipados com fechaduras inteligentes. Configure os códigos de acesso que serão fornecidos aos hóspedes.`,

  p97: `ChatBot IA`,
  p98: `Adicione o serviço de chatbot com IA e automatize as perguntas dos seus hóspedes de forma rápida e eficiente.`,

  p99: `Tem certeza de que deseja continuar com o processo?`,
  p100: `Atualizar assinatura`,

  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,

};
